class ClientActionFilter {
  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_OVERDUE() {
    return 'Overdue';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_WITHIN() {
    return 'Within';
  }
}

export default ClientActionFilter;
